import { createFileRoute } from "@tanstack/react-router";

import { EngagementOverview } from "./-components/engagement-overview";

export const Route = createFileRoute(
  "/_user/my-coaching/clients/programs/$engagementId/",
)({
  staticData: { title: "Overview" },
  component: OverviewPage,
});

function OverviewPage() {
  const { engagementId } = Route.useParams();
  return <EngagementOverview engagementId={engagementId} />;
}
